import { number, shape, string } from 'prop-types'

export const notificationPropType = shape({
    category: string.isRequired,
    eventId: string.isRequired,
    eventTime: string.isRequired,
    messageType: number.isRequired,
    notificationId: string.isRequired,
    objectId: string.isRequired,
    scope: string.isRequired
})
